module.exports = __webpack_public_path__ + "80404aba5fca91ab58d9294cbdd9f368.png";